import { render, staticRenderFns } from "./FTMVault.vue?vue&type=template&id=5b00adca&"
import script from "./FTMVault.vue?vue&type=script&lang=js&"
export * from "./FTMVault.vue?vue&type=script&lang=js&"
import style0 from "./FTMVault.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports